import { RangeMode } from '../material-definition.vm';

export const RANGE_MODE = {
    MIN_MAX: 'MIN_MAX',
    TARGET_DEVIATION: 'TARGET_DEVIATION',
} as const satisfies Record<string, RangeMode>;
